import type { ReactNode } from 'react';
import { motion, useReducedMotion } from 'motion/react';

/** Quick ease-out shared by the page transitions of the marketplace: brisk, not dramatic. */
const FADE_EASE = [0.2, 0, 0, 1] as const;

/**
 * Fades the body of a marketplace page in when `fadeKey` changes. Only the body: the page
 * header (banner, title, breadcrumb) is rendered outside and changes without animation.
 */
export default function PageFade({ fadeKey, className, children }: { fadeKey: string; className?: string; children: ReactNode }) {
    const reduceMotion = useReducedMotion();
    return (
        <motion.div
            key={fadeKey}
            initial={reduceMotion ? false : { opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: reduceMotion ? 0 : 0.16, ease: FADE_EASE }}
            className={className}
        >
            {children}
        </motion.div>
    );
}
